import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eBusTuyenDuongActionTypeIds, IBusTuyenDuongActionTypes } from "../../action-types/bus/IBusTuyenDuongActionTypes";
import { IBusTuyenDuongPageStateModel } from "../../page-state-model/bus/IBusTuyenDuongPageState";

const initialState: IBusTuyenDuongPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	bus_tuyenduongs: [],
	bus_tuyenduong_editing: undefined,
	bus_tuyenduong_selected_ids: [],
	bus_xes: [],
	bus_laixes: [],
	bus_monitorings: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false,
	is_show_import_modal: false,
	import_status: ePageBaseStatus.is_not_initialization,
	import_validated_datas: []
}

export const busTuyenDuongReducer = (state: IBusTuyenDuongPageStateModel = initialState, action: IBusTuyenDuongActionTypes): IBusTuyenDuongPageStateModel => {
	switch (action.type) {
		case eBusTuyenDuongActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading,
				bus_tuyenduong_selected_ids: []
			}
		case eBusTuyenDuongActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_tuyenduongs: action.payload
			}
		case eBusTuyenDuongActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				bus_tuyenduongs: []
			}
		case eBusTuyenDuongActionTypeIds.LOAD_XE_START:
			return {
				...state
			}
		case eBusTuyenDuongActionTypeIds.LOAD_XE_SUCCESS:
			return {
				...state,
				bus_xes: action.payload
			}
		case eBusTuyenDuongActionTypeIds.LOAD_XE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_xes: []
			}
		case eBusTuyenDuongActionTypeIds.LOAD_LAIXE_START:
			return {
				...state
			}
		case eBusTuyenDuongActionTypeIds.LOAD_LAIXE_SUCCESS:
			return {
				...state,
				bus_laixes: action.payload
			}
		case eBusTuyenDuongActionTypeIds.LOAD_LAIXE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_laixes: []
			}
		case eBusTuyenDuongActionTypeIds.LOAD_MONITORING_START:
			return {
				...state
			}
		case eBusTuyenDuongActionTypeIds.LOAD_MONITORING_SUCCESS:
			return {
				...state,
				bus_monitorings: action.payload
			}
		case eBusTuyenDuongActionTypeIds.LOAD_MONITORING_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				bus_monitorings: []
			}
		case eBusTuyenDuongActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				bus_tuyenduong_editing: action.payload
			}
		case eBusTuyenDuongActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				bus_tuyenduong_editing: undefined
			}
		case eBusTuyenDuongActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				bus_tuyenduong_selected_ids: action.payload
			}
		case eBusTuyenDuongActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eBusTuyenDuongActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eBusTuyenDuongActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eBusTuyenDuongActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật tuyến thành công" : "Thêm tuyến mới thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				bus_tuyenduong_editing: undefined
			}
		case eBusTuyenDuongActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eBusTuyenDuongActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eBusTuyenDuongActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xóa tuyến đường thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				bus_tuyenduong_editing: undefined,
				bus_tuyenduong_selected_ids: []
			}
		case eBusTuyenDuongActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		case eBusTuyenDuongActionTypeIds.SHOW_IMPORT_MODAL:
			return {
				...state,
				is_show_import_modal: true,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eBusTuyenDuongActionTypeIds.CLOSE_IMPORT_MODAL:
			return {
				...state,
				is_show_import_modal: false,
				import_status: ePageBaseStatus.is_not_initialization,
				import_validated_datas: []
			}
		case eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_loading
			}
		case eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_SUCCESS:
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: action.payload || []
			}
		case eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed,
				import_validated_datas: []
			}
		case eBusTuyenDuongActionTypeIds.IMPORT_START:
			return {
				...state,
				import_status: ePageBaseStatus.is_saving
			}
		case eBusTuyenDuongActionTypeIds.IMPORT_SUCCESS:
			NotifyHelper.Success("Import tuyến đường thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				import_status: ePageBaseStatus.is_completed,
				is_show_import_modal: false,
				import_validated_datas: []
			}
		case eBusTuyenDuongActionTypeIds.IMPORT_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				import_status: ePageBaseStatus.is_completed
			}
		default:
			return state;
	}
}
